var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"virtualRecipientsRegisterModal","title":"Rejestr projektowanych odbiorców","buttons":[],"register":_vm.register}},[_c('VirtualRecipientsTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c5bd95","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/modelWat/modals/VirtualRecipientsRegister.vue
// module id = 1841
// module chunks = 0